import * as React from "react"
import { RevenueOverviewHighlights } from "src/frontend/components/OS/Applications/Analysis/Revenue/Overview/RevenueOverviewHighlights"
import { RevenueOverviewWidget } from "src/frontend/components/OS/Applications/Analysis/Revenue/Overview/Widgets/RevenueOverviewWidget"

/*
  COMPONENTS
*/

export const RevenueOverview: React.FC = () => (
  <>
    <RevenueOverviewWidget />
    <RevenueOverviewHighlights />
  </>
)
